export default __webpack_public_path__ + "media/images/app-icon-99273c645b5a78494a5635186df2f482.svg";